import { Link } from "@mui/material";
import { IPdfLinkProps } from "../types/interfaces/IPdfLinkProps";
import { modifyUrl } from "../../global/utilities/UrlToIlpPdf";


//This component is responsible for rendering the pdf link for competencies. 
const PdfLink: React.FC<IPdfLinkProps> = ({ competency, onLinkClick }) =>  {
    const handleLinkClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        onLinkClick(event);
    };

    return (
        <>
            <Link 
                href={modifyUrl(competency?.Link!)} 
                underline="hover"
                color="primary.dark"
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleLinkClick}
                sx={{ flexShrink: 0 }}>
                More Info
            </Link>
        </>
    );
}

export default PdfLink;